<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "unionId":"xxxx"
           },
            responseCode: {"data":{


            },"message":"业务成功","resultCode":0,"status":1}	,
            infoData: {
                explain: "同步用户车辆权限",
                t_url: this.commonUrls.test+"syncUserCarPermission",
                p_url: this.commonUrls.prod+"syncUserCarPermission",
                precondition: "无",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'appId', info2: '否', info3: 'String', info4: '公众号 APPID' },
                        { info1: 'unionId', info2: '是', info3: 'String', info4: '用户unionId（unionId和openId不能同时为空）' },
                        { info1: 'openId', info2: '是', info3: 'String', info4: 'openId（unionId和openId不能同时为空）' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'carCodeColor', info2: '否', info3: 'String', info4: '车牌颜色：0其他，1蓝色，2黄色，3白色，4黑色，5绿色（默认为1）' },
                        { info1: 'allowOtherPay', info2: '否', info3: 'String', info4: '是否允许他人代缴(默认true)' },
                        {info1:"operateTime",info2:"是",info3:"String",info4:"操作时间，yyyyMMddHHmmss"}
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        // { info1: 'openId', info2: '是', info3: 'String', info4: '用户openId' },
                        ]
                    },
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/syncUserCarPermission.vue